import { useSelector } from 'react-redux';

/**
 * Get a single config default value
 * @param {string} context  - e.g. "Warrants", "Bookings"
 * @param {string} name     - e.g. "ORI", "Arrest_Date"
 * @returns {string|null}   - the raw valueDefault string
 */
export const useConfigDefault = (context, name) => {
  return useSelector(state =>
    state.config.configDefaults?.find(
      d => d.valueContext === context && d.valueName === name
    )?.valueDefault ?? null
  );
};

/**
 * Get all defaults for a given context as a flat {name: value} map
 * @param {string} context  - e.g. "Warrants"
 * @returns {Object}
 */
export const useConfigDefaultsByContext = (context) => {
  return useSelector(state => {
    const items = state.config.configDefaults?.filter(
      d => d.valueContext === context
    ) ?? [];
    return Object.fromEntries(items.map(d => [d.valueName, d.valueDefault]));
  });
};